<sc-sub-title>
  <sc-dictionary-label [dictionaryKey]="dictionaryKey"></sc-dictionary-label>
</sc-sub-title>
